// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ITouchSessionRequest {
    static getAttributeTypeMap() {
        return ITouchSessionRequest.attributeTypeMap;
    }
}
ITouchSessionRequest.discriminator = undefined;
ITouchSessionRequest.attributeTypeMap = [
    {
        "name": "key",
        "baseName": "key",
        "type": "string"
    },
    {
        "name": "token",
        "baseName": "token",
        "type": "string"
    }
];
//# sourceMappingURL=iTouchSessionRequest.js.map